import { useAppSelector } from '../../../store/hook';
import { selectLmsLists } from '../../../store/features/lmsSlice';
import { useParams } from 'react-router-dom';
import Notice from '../../../components/lms/dashboard/notice/Notice';
import QuickAccess from '../../../components/lms/dashboard/quick-access/QuickAccess';
import RecentActivity from '../../../components/lms/dashboard/recent-activity/RecentActivity';

/**
 * 개편 LMS (교사) - 클램스 홈 페이지
 */
const Dashboard = () => {
  const { classId } = useParams();

  const lmsLists = useAppSelector(selectLmsLists);

  return (
    <section className="flex flex-col gap-5 p-3 xl:p-5">
      {lmsLists && classId === lmsLists.id && (
        <>
          <Notice lmsLists={lmsLists} />
          <QuickAccess classId={classId} lmsLists={lmsLists} />
          <RecentActivity classId={classId} lmsLists={lmsLists} />
        </>
      )}
    </section>
  );
};

export default Dashboard;
